import { useMemo } from "react";
import { useParams } from "react-router";
/**
 * Returns the context IDs, such as packageID, branchID, savepointID and
 * processID.
 *
 * Can be used as a single source of truth everywhere. We can then chose to
 * remap it to either using params from URL to derive the IDs or
 * some other context.
 */
export const useStudioURLParams = () => {
  const params: {
    id?: string;
    branch?: string;
    savepoint?: string;
    process?: string;
    processSavepointId?: string;
  } = useParams();
  const environment = window.location.hostname.split(".")[1];
  // conversions
  const appId = +(params.id || 0);
  const branchId = +(params.branch || 0);
  const savepointId = +(params.savepoint || 0);
  const processId = +(params.process || 0);
  const processSavepointId = +(params.processSavepointId || 0);

  const isValidWFDesignerPage = useMemo(() => {
    return !!(
      processSavepointId &&
      processId &&
      savepointId &&
      branchId &&
      appId
    );
  }, [processSavepointId, processId, savepointId, branchId, appId]);

  return {
    appId,
    branchId,
    savepointId,
    processId,
    processSavepointId,
    environment,
    isValidWFDesignerPage
  };
};
